import * as React from "react";
import Button from "./button";

interface WalletLimitWarningProps {
  className?: string;
  onClose: () => void;
  onClick: () => void;
}

export default function WalletLimitWarning({
  className,
  onClose,
  onClick,
}: WalletLimitWarningProps) {
  return (
    <div className={`${className}`}>
      <div className="relative">
        <header className="relative flex justify-between items-center pl-[20px] pr-[20px] pt-[12px] pb-[12px] bg-[#FF0000]">
          <div className="text-[30px]">
            <span>ATTENTION</span>
          </div>
          <div
            className="absolute right-[20px] w-[29px] h-[29px] hover:cursor-pointer"
            onClick={onClose}
          >
            <img src="/assets/cancel.svg" alt="cancel" />
          </div>
        </header>
        <main className="flex flex-col justify-center bg-black items-center pt-[30px] pb-[50px] pl-[30px] pr-[30px] text-[21px]">
          <h1 className="text-[28px] text-primary-red mb-[20px]">
            WALLET LIMIT REACHED
          </h1>
          <h1 className="text-[24px] text-white mb-[20px] break-words">
            MAX 70 <span className="text-primary-red">WALLETS</span> ALLOWED.
            EXTRA WALLETS REMOVED AUTOMATICALLY.
          </h1>
          <div className="pt-[30px] w-full">
            <Button
              className="w-full custom-aspect-320-63 text-[24px] hover:cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out"
              image="/assets/button.svg"
              text="NEXT"
              onClick={onClick}
            />
          </div>
        </main>
      </div>
    </div>
  );
}
